import { BaseScript } from './BaseScript';

export class ConstantScript extends BaseScript {
	/**
	 * Запустить скрипт в контексте hostObject
	 */
	override runScript = () => {
		if (!this.Content) {
			return null;
		}
		this.Content = this.Content.trim();
		try {
			if (this.Content === 'DateTime.Now') {
				return new Date();
			} else if (this.Content === 'false') {
				return false;
			} else if (this.Content === 'true') {
				return true;
			} else {
				return this.Content;
			}
		} catch (e: any) {
			console.warn('', e.message);
		}
		return null;
	};
}
